import type { EventBusPayload } from "@/modules/event-bus";

import { useQueryClient } from "@tanstack/react-query";

import { isNotificationBroadcastObservationTransitionPayload } from "@/entities/notification-broadcast";
import { useInvalidateNotificationsDatabase } from "@/entities/notifications-database";
import { useGetSettingsNotifications } from "@/entities/settings";
import { useAppNotification } from "@/modules/app-notification";

import { notifyObservationTransition } from "./observation-action-transition.helper";

export const useObservationActionTransition = () => {
  const { notify } = useAppNotification();
  const queryClient = useQueryClient();
  const { invalidateNotifications } = useInvalidateNotificationsDatabase();
  const { isBroadcastNotificationEnabled } = useGetSettingsNotifications();

  const runAction = (payload: EventBusPayload) => {
    if (!isNotificationBroadcastObservationTransitionPayload(payload)) return;
    if (
      isBroadcastNotificationEnabled(`transition-observation:${payload.state}`)
    ) {
      notifyObservationTransition({ notify, payload });
    }
    queryClient.invalidateQueries({
      queryKey: ["observations"],
    });
    invalidateNotifications("*");
  };

  return { runAction };
};
